import {
  CONNECTORS,
  FULLL_AUTHORIZE_URL,
  FULLL_OAUTH_CALLBACK_REDIRECT_URI,
  PENNYLANE_AUTHORIZE_URL,
  PENNYLANE_OAUTH_CALLBACK_REDIRECT_URI,
  TIIME_AUTHORIZE_URL,
  TIIME_CLIENT_ID,
  TIIME_OAUTH_CALLBACK_REDIRECT_URI
} from '../const';

const TIIME_SCOPE = 'accounting:read offline_access';

const generateExternalConnectorLoginRedirectUrl = (connectorId, options) => {
  const {clientId, scope, state} = options;
  const responseType = 'code';

  if (connectorId === CONNECTORS.tiime) {
    const audience = 'https://api.tiime.fr/';

    // prettier-ignore
    const url =
      `${TIIME_AUTHORIZE_URL}` +
      `?scope=${TIIME_SCOPE}` +
      `&client_id=${TIIME_CLIENT_ID}` +
      `&audience=${audience}` +
      `&response_type=${responseType}` +
      `&state=${state}` +
      `&redirect_uri=${TIIME_OAUTH_CALLBACK_REDIRECT_URI}`;

    return url;
  }

  if (connectorId === CONNECTORS.pennylane) {
    // prettier-ignore
    const url =
      `${PENNYLANE_AUTHORIZE_URL}` +
      `?client_id=${clientId}` +
      `&response_type=${responseType}` +
      `&state=${state}` +
      `&redirect_uri=${PENNYLANE_OAUTH_CALLBACK_REDIRECT_URI}` +
      `&scope=${scope}`;

    return url;
  }

  if (connectorId === CONNECTORS.fulll) {
    // prettier-ignore
    const url =
      `${FULLL_AUTHORIZE_URL}` +
      `?client_id=${clientId}` +
      `&state=${state}` +
      `&redirect_uri=${FULLL_OAUTH_CALLBACK_REDIRECT_URI}`;

    return url;
  }

  return '';
};

export {generateExternalConnectorLoginRedirectUrl};
